import { createAsyncThunk } from '@reduxjs/toolkit';
import { uniq } from 'lodash';
import { getUsers } from 'store/chat/services/getUsers';
import fetchFile from 'utils/fetchFile';

export const loadVideoChatUsers = createAsyncThunk(
  'videoChat/loadUsers',
  async (userIds) => {
    const uniqueUserIds = uniq(userIds);
    const response = uniqueUserIds.length
      ? await getUsers(uniqueUserIds)
      : { users: [] };

    const users = {};

    for (const user of response.users) {
      let imageSrc = null;
      if (user.image) {
        imageSrc = await fetchFile(`thumbs/${user.image.key}`);
      }
      users[user.id] = {
        ...user,
        image: imageSrc,
      };
    }

    return users;
  }
);
